import React from 'react';

const About = () => {
	return (
		<div name='about' className='about w-full h-screen bg-[#0a192f] text-gray-300'>
				<div className='flex flex-col justify-center items-center w-full h-full'>
						<div className='max-w-[1000px] w-full grid grid-cols-2 gap-8'>
								<div className='sm:text-right pb-8 pl-4'>
										<p className='text-4xl font-bold inline border-b-4 border-pink-600'>
												About
										</p>
								</div>
								<div></div>
								</div>
								<div className='max-w-[1000px] w-full grid sm:grid-cols-2 gap-8 px-4'>
										<div className='sm:text-right text-4xl font-bold'>
												<p>Hi. I'm Mykyta, nice to meet you. Please take a look around.</p>
										</div>
										<div>
												<p>
													   As Junior Front-End Developer i'm responsible for building and maintaining web applications. 
													   I want to work with the development team, as well as React and React Native developer. 
													   I make optimized web designs for mobiles and other platforms for maximum speed. 
													   My goal is to work with designers and with professional front-end developers to ensure high-quality graphic standards and brand consistency.
												</p>
										</div>
						</div>
				</div>
		</div>
	)
}

export default About;